<template>
  <LibBaseIcon :size="size">
    <g>
      <path class="" d="m42.54 99h34.928a6 6 0 0 0 5.98-5.518l4.557-56.482h-56l4.555 56.482a6 6 0 0 0 5.98 5.518zm29.898-51.07a1.5 1.5 0 1 1 2.996 0.14l-1.874 39.336a1.5 1.5 0 0 1-1.496 1.43l-0.072-3e-3a1.5 1.5 0 0 1-1.427-1.57zm-13.938 0.07a1.5 1.5 0 0 1 3 0v39.334a1.5 1.5 0 0 1-3 0zm-12.508-1.5a1.492 1.492 0 0 1 1.57 1.43l1.872 39.332a1.5 1.5 0 0 1-1.426 1.57h-0.073a1.5 1.5 0 0 1-1.497-1.427l-1.873-39.335a1.5 1.5 0 0 1 1.427-1.57zm9.59-18.5v-1h-23.585v6h56.008v-6h-23.588v1h-8.834m0-6h8.833v5h-8.833z" />
      <path class="" d="m55.583 27h8.833v1h-8.833z" />
      <path class="" d="m55.583 27h8.833v1h-8.833z" />
    </g>
  </LibBaseIcon>
</template>

<script lang="ts">
import Vue from 'vue'
import LibBaseIcon, { props } from './LibBaseIcon.vue'

export default Vue.extend({
  components: {
    LibBaseIcon,
  },
  props,
})
</script>
